module.exports = __webpack_public_path__ + "static/media/tipo5.f4585270.png";